import type ChartCardStore from "../ChartCardStore";
import type Classifier from "models/ClassifierModel";

export const ALL_CLASSIFIERS_CATEGORY_ID = "all-classifiers";

export function normalizeClassifierCategoryId(
    categoryId?: string,
): string | undefined {
    if (!categoryId || categoryId === ALL_CLASSIFIERS_CATEGORY_ID) {
        return undefined;
    }

    return categoryId;
}

export function getClassifierOptionsForCategory(
    chartStore: ChartCardStore,
    categoryId?: string,
): Classifier[] {
    const normalizedCategoryId = normalizeClassifierCategoryId(categoryId);

    if (!normalizedCategoryId) {
        return chartStore.optionsStore.userClassifiers;
    }

    return chartStore.optionsStore.userClassifiers.filter(
        (classifier) =>
            classifier.classifierCategory?.id === normalizedCategoryId,
    );
}

export function getValidatedClassifierSelection(
    ids: string[] | undefined,
    options: Classifier[],
    maxSelection: number,
): string[] | undefined {
    if (!ids?.length) return undefined;

    const validIds = ids
        .filter((id) => options.some((classifier) => classifier.id === id))
        .slice(0, maxSelection);

    return validIds.length ? validIds : undefined;
}
